import axios from '@axios'

/** 
* Índice
* {@link getAccountingAccounts} - Obtener cuentas contables
* {@link getAccountingAccount} - Obtener cuenta contable
* {@link addAccountingAccount} - Crear cuenta contable
* {@link deleteAccountingAccount} - Eliminar cuenta contable
* {@link updateAccountingAccount} - Actualizar cuenta contable
* {@link getAccountingGroups} - Obtener grupos contables
*/

    /**
     * Obtener todads las cuenta contables
     * @param {*} queryParams 
     * @returns accounting_accounts
     */
    export const getAccountingAccounts = function (queryParams) {
        try {
            return new Promise((resolve, reject) => {
                axios
                    .get('/accounting-accounts', { params: queryParams })
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })

        } catch (error) {
            return error
        }
    }

    /**
     * Obtener cuenta contable
     * @param {integer} id ID de la cuenta contable 
     * @returns acocunting_account
     */

    export const getAccountingAccount = function ( id ) {
        try {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/accounting-accounts/${id}`)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })

        } catch (error) {
            return error
        }
    }

    /**
     * Añadir cuenta contable
     * @param {*} data Datos del cliente 
     * @returns 
     */

    export const addAccountingAccount = function (data) {
        try {
            return new Promise((resolve, reject) => {
                axios
                    .post(`/accounting-accounts`, data)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })

        } catch (error) {
            return error
        }
    }

    /**
     * Borrar cuenta contable
     * @param {integer} id ID de la cuenta contable a borrar
     * @returns 
     */

    export const deleteAccountingAccount = function ({ id }) {
        try {
            return new Promise((resolve, reject) => {
                axios
                    .delete(`/accounting-accounts/${id}`)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })

        } catch (error) {
            return error
        }
    }

    /**
     * Actualizar cuenta contable
     * @param {integer} id ID de la cuenta contable a actualizar 
     * @returns 
     */

    export const updateAccountingAccount = function (data) {
        try {
            return new Promise((resolve, reject) => {
                axios
                    .put(`/accounting-accounts/${data.id}`, data)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })

        } catch (error) {
            return error
        }
    }

    /**
     * Obtener todads los grupos contables
     * @param {*} queryParams 
     * @returns accounting_groups
     */
    export const getAccountingGroups = function (queryParams) {
        try {
            return new Promise((resolve, reject) => {
                axios
                    .get('/accounting-groups', { params: queryParams })
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })

        } catch (error) {
            return error
        }
    }









